import { observer } from 'mobx-react-lite'
import LevelProgressBar from './LevelProgressBar'
import clsx from 'clsx'
import { useRunState } from '@/src/game/provider/useRunState'
import { getLevelProgress } from '@/src/game/config/levels'

export const LevelProgressDisplay = observer(function LevelProgressDisplay() {
    const runState = useRunState()
    const { progress, current, target } = getLevelProgress(runState.points)

    return (
        <>
            <div className={clsx(
                'left-1/2 z-50 absolute -translate-x-1/2',
                'top-2.75',
                'stele:top-10',
            )}>
                <LevelProgressBar
                    progress={progress}
                    label={`${current} / ${target}`}
                />
            </div>
        </>
    )
})